export const statusColorList={
'Accepted':'#50AF78',
'Approved':'#50AF78',
'Pending':'#FF9742',
'Draft':'#FF9742',
'ReWork':'#8585E0',
'Edit':'#3E7CA6',
'For Review':'#8585E0',
'Ready for review':'#8585E0'
};